import { Outlet } from '@tanstack/react-router';
import { Header } from './Header.tsx';

export function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-[var(--gray-2)]">
      <Header />
      <main className="flex-1 p-4 lg:p-6">
        <Outlet />
      </main>
    </div>
  );
}
